import PersonaRelatedFiles from "../../../../../tags/persona-related-files.marko";

const/d=$global.data

div.container--persona-search
  a.back-link href=`/tools/persona/${d.game}` -- ← Database Search
  header
    h1.persona-page-title -- ${d.displayName || d.file}
    p.subtitle -- ${d.gameTitle} dialogue
    p.file-path style="font-size: 0.8rem; color: var(--muted-foreground); overflow-wrap: anywhere;"
      -- File: 
      code -- ${d.file}
    if=d.summary
      p style="color: var(--muted-foreground); margin-top: 0.5rem;"
        -- Context:
        i -- ${d.summary}
  if=d.overview
    section.persona-overview aria-label="File overview"
      h2 -- Overview
      p -- ${d.overview}
  if=d.error
    div.message-card style="border-color: #ef4444; color: #ef4444;" -- ${d.error}
  div
    for|vm| of=d.messages
      div.message-card
        ,class={ highlighted: vm.is_highlight }
        ,id=(vm.is_highlight ? "highlight" : (vm.msg_id || ""))
        ,style=(vm.reply_context ? "margin-left: 1.5rem; margin-bottom: 0.5rem;" : "")
        if=vm.reply_context
          div.reply-context
            span
              -- Response to selection: 
              strong -- ${vm.reply_context}
        div.flex
          div.message-speaker -- ${vm.speaker || ""}
          div.message-key -- ${vm.msg_id || ""}
        div.message-content -- $!{vm.formatted_content}
        div.message-raw -- ${vm.raw_content}
    if=d.highlightId
      script
        -- document.getElementById('highlight')?.scrollIntoView({ block: 'center' });
  PersonaRelatedFiles related=d.related
  footer style="margin-top: 3rem; font-size: 0.8rem; color: var(--muted-foreground); border-top: 1px solid var(--border); padding-top: 1rem;"
    p
      strong -- Font License Info:
      --  Agane font was used for dialogues, made by
      a href="https://danieledemarco.com/" -- Danilo De Marco
      -- .
